export default {"src":"https://fishbrain.com/_next/static/media/arkansas.0ffd31f4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};